'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingContainer = exports.loadingBuilder = undefined;

var _reactRedux = require('react-redux');

var _Loading = require('../../Presentational components/Pages/Loading/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _actions = require('./actions');

var Actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingBuilder = exports.loadingBuilder = function loadingBuilder(mapStateToProps) {
  return (0, _reactRedux.connect)(mapStateToProps, Actions)(_Loading2.default);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    visible: state.framework.loader.visible,
    overlay: state.framework.loader.overlay
  };
};

var LoadingContainer = exports.LoadingContainer = loadingBuilder(mapStateToProps);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/LoadingContainer/LoadingContainer.js
 ** module id = 473
 ** module chunks = 0
 **/